import { Component, OnInit, ComponentRef, AfterViewInit } from '@angular/core';
import { IModalDialog, IModalDialogOptions, IModalDialogButton } from 'ngx-modal-dialog';
import {FormGroup, FormControl, Validators, AbstractControl} from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { Onboarding, Sex } from '../../../models/onboarding';
import { Addresses } from '../../../models/addresses';
import * as CodiceFiscale from 'codice-fiscale-js';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import {addIdToSelectInputElement}  from '../../../utils/addIdToSelectInputElement';

@Component({
  selector: 'alg-cf-modal',
  templateUrl: './alg-cf-modal.component.html',
  styleUrls: ['./alg-cf-modal.component.scss']
})
export class AlgCfModalComponent implements OnInit, IModalDialog, AfterViewInit {
  public description: string;
  public actionButtons: IModalDialogButton[];
  public cfForm: FormGroup;
  public onboarding: Onboarding = {} as Onboarding;

  public codiceFiscale: string;

  public day: string;
  public month: string;
  public year: string;
  public firstname: string;
  public lastname: string;
  public place: string;
  public province: string;
  public provinces = this.getAreaCodes();
  public cities = [];
  public sex: Sex;
  public sexOptions = [{
    label: 'Uomo',
    value: Sex.male
  }, {
    label: 'Donna',
    value: Sex.female
  }];


  constructor(private api: ApiService, private utils: UtilsService, private gtm: AlgGtmService) {
    this.actionButtons = [
      { text: '', buttonClass: 'alg-btn-close', onAction: () => {
        this.utils.abilityOverflow();
        return true;
      } },
      { text: 'Calcola', buttonClass: 'button-reload-product', onAction: () => {
        if (this.cfForm.status === 'VALID') {
         this.utils.abilityOverflow();
         return this.calculateCF();
        } else {
          return false;
        }
      }
    }];
  }

  ngAfterViewInit(){
    const selectComune = document.getElementById("select-comune-cf");
    const selectProvincia = document.getElementById("select-provincia-cf");
    if(selectComune) addIdToSelectInputElement('select-input-comune-cf', selectComune);
    if(selectProvincia) addIdToSelectInputElement('select-input-provincia-cf', selectProvincia);
    console.log(document.getElementsByClassName('button-reload-product'))
    setTimeout(()=>{
      document.getElementsByClassName('button-reload-product')[0].setAttribute('id', 'button-caluclateCF')
      const exitButton = document.getElementsByClassName('alg-btn-close');
      // if(!exitButton[0]) return     
      exitButton[0].setAttribute('id', 'fiscalCode-exit');
      exitButton[0].setAttribute('type', 'button');
    }, 500)
  }

  ngOnInit() {
    if(!this.onboarding){
      this.api.currentOnboarding.subscribe(onb => {
        this.onboarding = onb;
      });
    }
    this.cfForm = new FormGroup({
      sex: new FormControl(this.sex, {
        validators: [Validators.required]
      }),
      day: new FormControl(this.day, {
        validators: [Validators.required, Validators.min(1), Validators.max(31)]
      }),
      month: new FormControl(this.month, {
        validators: [Validators.required, Validators.min(1), Validators.max(12)]
      }),
      year: new FormControl(this.year, {
        validators: [Validators.required, Validators.min(1900), Validators.max(2018)]
      }),
      place: new FormControl(this.place, {
        validators: [Validators.required]
      }),
      province: new FormControl(this.province, {
        validators: [Validators.required]
      })
    });
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    this.description = options.data.description
    this.onboarding = options.data.onboarding;
  }

  changeSex(event) {
    if (event.target.value === 'true') {
      if (event.target.value === 'M') {
        this.sex = Sex.male;
      } else {
        this.sex = Sex.female;
      }
    }
   }

  changeAreaCodes(event) {
    this.cities = CodiceFiscale.CODICI_CATASTALI[event.target.value].map(function(item) {
      return {
        label: item[0],
        value: item[0]
      };
    });
  }

  getAreaCodes() {
    let areas = [];
    let keys = Object.keys(CodiceFiscale.CODICI_CATASTALI);
    for(let i = 1; i < keys.length; i++){
      areas.push({label: keys[i], value: keys[i]});
    }
    return areas;
  }

  calculateCF() {
    let birthDate = `${this.year}/${this.month}/${this.day}`;
    try {
      this.codiceFiscale = CodiceFiscale.compute({
        name: this.onboarding.firstname,
        surname: this.onboarding.lastname,
        gender: this.sex,
        day: this.day,
        month: this.month,
        year: this.year,
        birthplace: this.place,
        birthplaceProvincia: this.province
      });
      this.onboarding.cf = this.codiceFiscale;
      this.onboarding.sex = this.sex;
      this.onboarding.birthDate = birthDate;
      this.onboarding.city = this.place;
      this.onboarding.province = this.province;
      this.api.saveOnboarding(this.onboarding, false);
      this.gtm.submitOnbEvent('Inserimento codice fiscale', 'ok')
      return true;
    } catch (err) {
      this.gtm.submitOnbEvent('Inserimento codice fiscale', 'error')
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-cf-modal/alg-cf-modal.component.ts